import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormControl, AbstractControl, ValidationErrors } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription, filter } from 'rxjs';
import { Application, FileTypes, Mpi, Fabric, ApplicationTypes } from 'src/app/core/models/application';
import { Deployment } from 'src/app/core/models/deployment';
import { ApplicationService } from 'src/app/core/services/application.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { UploadFileTypes } from '../../../../core/models/globals';
import { DeploymentService } from '../../../../core/services/deployment.service';
import { FileEditorComponent } from '../../../job/modals/jobActions/file-editor/file-editor.component';

@Component({
  selector: 'app-add-application',
  templateUrl: './add-application.component.html',
  styleUrls: ['./add-application.component.scss']
})
export class AddApplicationComponent implements OnInit {
  application: Application = this.data.application;
  isClone: boolean = this.data.isClone;

  constructor(
    private dialog: MatDialogRef<AddApplicationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { application: Application, isClone: boolean },
    private authenticationService: AuthenticationService,
    private applicationService: ApplicationService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialog,
    private deploymentService: DeploymentService
  ) {}

  addApplicationForm: UntypedFormGroup;
  deployments: Deployment[];
  apps: Application[];
  depName;
  appValue;
  appNames = [];
  types: FileTypes[] = [
    { name: 'Execute File', value: 'Execute File' },
    { name: 'License File', value: 'License File' },
    { name: 'Cancel File', value: 'Cancel File' },
    { name: 'Resume File', value: 'Resume File' },
    { name: 'Suspend File', value: 'Suspend File' }
  ];
  mpis: Mpi[] = [
    { name: 'Intel MPI', value: '0' },
    { name: 'MPICH', value: '1'},
    { name: 'OpenMPI', value: '2'},
    { name: 'Platform MPI', value: '3'},
  ]
  fabrics: Fabric[] = [
    { name: 'dapl', value: '0' },
    { name: 'tcp', value: '1'},
    { name: 'shm', value: '2'},
    { name: 'tmi', value: '3'},
    { name: 'ofa', value: '4'},
    { name: 'ofi', value: '5'},
    { name: 'efa', value: '6'}
  ]
  applicationTypes: { name: string, value: string | ApplicationTypes }[] = Object.entries(ApplicationTypes)
    .filter(([name, value]) => isNaN(Number(name)))
    .map(([name, value]) => ({ name, value }));
  scriptUploadSub: Subscription;
  executeFile: File;
  licenseFile: File;
  cancelFile: File;
  resumeFile: File;
  suspendFile: File;
  toShow: boolean = false;
  uploadFlag: boolean = false;
  scriptFileUploadPer: string;
  cancelledFiles = {};
  queuesFromDep: string[] = [];
  routeViaSynchpc: boolean = this.deploymentService.getProfileInfoFromSubject(this.applicationService?.tempDeployName)?.routeViaSynchpc || false;

  @ViewChild('chooseAppFile') chooseAppFile;

  onFileChange(inputName) { 
		switch (inputName){
			case 'chooseAppFile':
				this.chooseAppFile.nativeElement.value = null;
		}
	}

  ngOnInit() {
    this.depName = this.applicationService.tempDeployName;
    this.applicationService.getNodeGroupsForDeployment(this.depName)
      .subscribe((data) => {
        if (data) {
          this.queuesFromDep = <string[]>JSON.parse(JSON.stringify(data));
        }
      });
    this.applicationService.getAllApplications(this.authenticationService.currentUserValue.username)
      .subscribe(data => {
        this.appNames = JSON.parse(JSON.stringify(data));
        this.appNames.splice(this.appNames.findIndex(item => item === 'Other'),1);
        this.appNames.splice(this.appNames.findIndex(item => item === 'Command'),1);
        this.appNames.push("Other")
        if(this.data.application){
          const appName = this.data.application.appName;
          if(this.appNames.indexOf(appName) == -1){
            this.addApplicationForm.controls['newApplication'].setValue("Other");
            this.addApplicationForm.controls['customAppName'].setValue(appName);
          } else {
            this.addApplicationForm.controls['newApplication'].setValue(appName);
          }
        }
      })
    this.addApplicationForm = new UntypedFormGroup({
      newAppDeployment: new UntypedFormControl(this.depName, Validators.required),
      newApplication: new UntypedFormControl(null, Validators.required),
      customAppName: new UntypedFormControl(null),
      newAppVersion: new UntypedFormControl(null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9-@_.]*$/)]),
      newAppMpi: new UntypedFormControl(this.mpis[0].value, Validators.required),
      applicationType: new UntypedFormControl(this.applicationTypes[0].value.toString(), Validators.required),
      newAppFabric: new UntypedFormControl(this.fabrics[4].value, Validators.required),
      newAppLicenseCheck: new UntypedFormControl('false', Validators.required),
      fileTypeApp: new UntypedFormControl(this.types[0], Validators.required),
      userScriptFile: new UntypedFormControl({ value: null, disabled: true }),
      staticCores: new UntypedFormControl(null, [Validators.pattern(/^\d+(,\d+)*$/)]),
      licence_File: new UntypedFormControl(null),
      execute_File: new UntypedFormControl(null),
      cancel_File: new UntypedFormControl(null),
      resume_File: new UntypedFormControl(null),
      suspend_File: new UntypedFormControl(null),
      applicationSpecificQueue: new UntypedFormControl(null),
      defaultMemorySpace: new UntypedFormControl(null, Validators.pattern('^[0-9]*$')),
    });
    this.autoFillDetails(); 
  }

  autoFillDetails() {
    if (this.data.application) {
      // this.addApplicationForm.controls['newApplication'].setValue(this.application.appName);
      this.addApplicationForm.controls['newAppVersion'].setValue(this.application.appVersionText);
      this.addApplicationForm.controls['staticCores'].setValue(this.application.staticCores);
      this.addApplicationForm.controls['defaultMemorySpace'].setValue(this.application.memoryPerCPU);
      this.addApplicationForm.controls['applicationSpecificQueue'].setValue(this.application.applicationNodeGroups);
    }
  }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit(form: UntypedFormGroup) {
    if (!form.valid) {
      this.addApplicationForm.markAllAsTouched();
    } else {
      let appData : Application = {
        userId: this.authenticationService.currentUserValue.username,
        depName: form.value.newAppDeployment,
        appName: form.value.newApplication,
        appVersion: form.value.newAppVersion,
        modules: form.value.newAppModule,
        mpi: form.value.newAppMpi,
        licenseCheckFlag: form.value.newAppLicenseCheck,
        fabric: form.value.newAppFabric,
        staticCores: form.value.staticCores,
        applicationNodeGroups: form.value.applicationSpecificQueue?.toString(),
        memoryPerCPU: form.value.defaultMemorySpace?.toString(),
        applicationType: form.value.applicationType
      }
      if(form.value.newApplication == 'Other'){
        appData.appName = form.value.customAppName
      }
      // Check if this is a clone operation and prepare source app ID
      const isClone = this.data.isClone && this.data.application;
      const sourceAppId = isClone ? this.data.application.appId : null;

      this.applicationService.addApplication(appData, form.value.newAppDeployment, sourceAppId)
        .subscribe({
          next: (event: HttpResponse<any>) => {
            if (event.status == 200) {
              if (this.executeFile || this.licenseFile || this.cancelFile || this.resumeFile || this.suspendFile) {
                if (this.executeFile) {
                  this.scriptUploadSub = this.applicationService.UploadApplicationFile(this.depName,
                    appData.appName, appData.appVersion, UploadFileTypes.ExecuteFile, this.executeFile)
                    .pipe(
                      filter((file) => !!file)
                    )
                    .subscribe({
                    });
                }
                if (this.licenseFile) {
                  this.scriptUploadSub = this.applicationService.UploadApplicationFile(this.depName,
                    appData.appName, appData.appVersion, UploadFileTypes.LicenseFile, this.licenseFile)
                    .pipe(
                      filter((file) => !!file)
                    )
                    .subscribe({
                    });
                }
                if (this.cancelFile) {
                  this.scriptUploadSub = this.applicationService.UploadApplicationFile(this.depName,
                    appData.appName, appData.appVersion, UploadFileTypes.CancelFile, this.cancelFile)
                    .pipe(
                      filter((file) => !!file)
                    )
                    .subscribe({
                    });
                }
                if (this.resumeFile) {
                  this.scriptUploadSub = this.applicationService.UploadApplicationFile(this.depName,
                    appData.appName, appData.appVersion, UploadFileTypes.ResumeFile, this.resumeFile)
                    .pipe(
                      filter((file) => !!file)
                    )
                    .subscribe({
                    });
                }
                if (this.suspendFile) {
                  this.scriptUploadSub = this.applicationService.UploadApplicationFile(this.depName,
                    appData.appName, appData.appVersion, UploadFileTypes.SuspendFile, this.suspendFile)
                    .pipe(
                      filter((file) => !!file)
                    )
                    .subscribe({
                    });
                }
                this.snackBar.open('Application Added Successfully', 'Ok', {
                  duration: 3000
                })
                this.dialog.close(true);
              }

              else {
                this.snackBar.open('Application Added Successfully', 'Ok', {
                  duration: 3000
                })
                this.dialog.close(true);
              }
            }
          }, error : (err: HttpErrorResponse) => {
            this.snackBar.open(err.error, 'Ok', {
              duration: 5000
            })
          }
        })
    }
  }

  uploadFiles(event, id?: string) {
    let selectedFileType = this.addApplicationForm.value.fileTypeApp.value;
    switch (selectedFileType) {
      case UploadFileTypes.ExecuteFile:
        this.executeFile = event.target.files[0];
        this.addApplicationForm.controls['execute_File'].setValue(this.executeFile.name);
        break;
      case UploadFileTypes.LicenseFile:
        this.licenseFile = event.target.files[0];
        this.addApplicationForm.controls['licence_File'].setValue(this.licenseFile.name);
        break;
      case UploadFileTypes.CancelFile:
        this.cancelFile = event.target.files[0];
        this.addApplicationForm.controls['cancel_File'].setValue(this.cancelFile.name);
        break;
      case UploadFileTypes.ResumeFile:
        this.resumeFile = event.target.files[0];
        this.addApplicationForm.controls['resume_File'].setValue(this.resumeFile.name);
        break;
      case UploadFileTypes.SuspendFile:
        this.suspendFile = event.target.files[0];
        this.addApplicationForm.controls['suspend_File'].setValue(this.suspendFile.name);
        break;
      default:
        break;
    }
  }

  removeFile(id?: string) {
    //this.executeFile = null
    //this.addApplicationForm.controls[id].setValue(null);
    switch (id) {
      case 'execute_File':
        this.executeFile = null;
        this.addApplicationForm.controls['execute_File'].setValue(null);
        break;
      case 'licence_File':
        this.licenseFile = null;
        this.addApplicationForm.controls['licence_File'].setValue(null);
        break;
      case 'cancel_File':
        this.cancelFile = null;
        this.addApplicationForm.controls['cancel_File'].setValue(null);
        break;
      case 'resume_File':
        this.resumeFile = null;
        this.addApplicationForm.controls['resume_File'].setValue(null);
        break;
      case 'suspend_File':
        this.suspendFile = null
        this.addApplicationForm.controls['suspend_File'].setValue(null);
        break;
      default:
        break;
    }
  }

  checkApplicationName(appName){
    if(appName == 'Other'){
      this.addApplicationForm.controls['customAppName'].setValidators([Validators.required, Validators.pattern(/[a-zA-Z0-9@_-]*$/)])
      this.addApplicationForm.controls['customAppName'].updateValueAndValidity()
    } else {
      this.addApplicationForm.controls['customAppName'].clearValidators()
      this.addApplicationForm.controls['customAppName'].updateValueAndValidity()
    }
  }

  openFileEditor(type) {
    const dialogRef = this.dialogRef.open(FileEditorComponent, {
      disableClose: true,
      autoFocus: false,
      width: "70%",
      height: "80%",
      id: "editorDialog",
      panelClass: "file-editor-dialog",
      hasBackdrop: false,
      data: {
        depName: this.depName,
        cloudType: '',
        filePath: '',
        routeViaSynchpc: this.routeViaSynchpc
      }
    }).afterClosed().subscribe({
      next: (data) => {
        if (data) {
          switch (type) {
            case UploadFileTypes.ExecuteFile:
              this.executeFile = data;
              this.addApplicationForm.controls['execute_File'].setValue(this.executeFile.name);
              break;
            case UploadFileTypes.LicenseFile:
              this.licenseFile = data;
              this.addApplicationForm.controls['licence_File'].setValue(this.licenseFile.name);
              break;
            case UploadFileTypes.CancelFile:
              this.cancelFile = data;
              this.addApplicationForm.controls['cancel_File'].setValue(this.cancelFile.name);
              break;
            case UploadFileTypes.ResumeFile:
              this.resumeFile = data;
              this.addApplicationForm.controls['resume_File'].setValue(this.resumeFile.name);
              break;
            case UploadFileTypes.SuspendFile:
              this.suspendFile = data;
              this.addApplicationForm.controls['suspend_File'].setValue(this.suspendFile.name);
              break;
            default:
              break;
          }
        }
      },
    })
  }

  createNewFile() {
    let selectedFileType = this.addApplicationForm.value.fileTypeApp.value;
    switch (selectedFileType) {
      case UploadFileTypes.ExecuteFile:
        this.openFileEditor(UploadFileTypes.ExecuteFile);
        break;
      case UploadFileTypes.LicenseFile:
        this.openFileEditor(UploadFileTypes.LicenseFile);
        break;
      case UploadFileTypes.CancelFile:
        this.openFileEditor(UploadFileTypes.CancelFile);
        break;
      case UploadFileTypes.ResumeFile:
        this.openFileEditor(UploadFileTypes.ResumeFile);
        break;
      case UploadFileTypes.SuspendFile:
        this.openFileEditor(UploadFileTypes.SuspendFile);
        break;
      default:
        break;
    }
  }
}
